import "date-fns";
import React from "react";
import Grid from "@material-ui/core/Grid";
import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from "@material-ui/pickers";

export default function DatePicker(props) {
  // The first commit of Material-UI
  const [selectedDate, setSelectedDate] = React.useState(new Date());

  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <Grid container justify="space-around">
        {props.control === "date" ? (
          <KeyboardDatePicker
            margin="normal"
            id={props.label + props.keys}
            label={props.label}
            format={props.format}
            value={props.value}
            onChange={(date) => props.handleDateChange(date, props.keys)}
            KeyboardButtonProps={{
              "aria-label": "change date",
            }}
            style={{ width: "80%" }}
          />
        ) : (
          <KeyboardTimePicker
            margin="normal"
            id={props.label + props.keys}
            label="Time picker"
            value={selectedDate}
            onChange={handleDateChange}
            KeyboardButtonProps={{
              "aria-label": "change time",
            }}
          />
        )}
      </Grid>
    </MuiPickersUtilsProvider>
  );
}
